module.exports = __webpack_public_path__ + "static/media/krivka.55efb549.svg";